module.exports = __webpack_public_path__ + "static/color3.f20c1fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/realfire/features/connection-colors/color3.png
// module id = 187
// module chunks = 62430881213916 95704636617618